export default {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  ID:  'ID',
  OUT: 'OUT',
  IN: 'IN',
  ERROR: 'ERROR',
  IF: 'IF',
  ENDIF: 'ENDIF',
  WHILE: 'WHILE',
  ENDWHILE: 'ENDWHILE',
  TYPE: 'TYPE',
  MATH: 'MATH',
  QUOTE: 'QUOTE',
  LITERAL: 'LITERAL',
  NONE: 'NONE',
  REFID: 'REFID',
} as any;
  